import fetch from '@/plugin/axios'

// 查询列表
export function getCoupon (query) {
  return fetch({
    url: '/api/common/user-coupon/list',
    method: 'Post',
    data: query
  })
}

// 核销
export function getCharge (query) {
  return fetch({
    url: '/api/common/user-coupon/charge-off',
    method: 'Post',
    data: query
  })
}
